/* eslint-disable */
import {
  Box,
  Button,
  Flex,
  FormControl,
  HStack,
  Icon,
  IconButton,
  ResponsiveValue,
  Select,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useColorModeValue,
} from "@chakra-ui/react";
import * as React from "react";
// Custom components

import { MdChevronLeft, MdChevronRight } from "react-icons/md";
// Assets
import { SearchBar } from "../../../components/navbar/searchBar/SearchBar";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useDispatch, useSelector } from "react-redux";
import {
  selectButtonLoading,
  selectList,
  selectLoading,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectTotalRow,
} from "./redux/selector";

import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import DateFormat from "../../../components/Common/DateFormat";
import { actions } from "./redux/slice";
import { IData } from "./types";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../components/Common/CommonModal/ConfirmationModal";
import { CommonTable } from "../../../components/CommonTable";

export default function Index() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const search = useSelector(selectSearch);
  const tableData = useSelector(selectList);
  const loading = useSelector(selectLoading);
  const total = useSelector(selectTotalRow);
  const orderBy = useSelector(selectOrderBy);
  const orderDir = useSelector(selectOrderDir);
  const buttonLoading = useSelector(selectButtonLoading);
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);
  const [selectedId, setSelectedId] = React.useState<string | null>(null);
  const [showModal, setShowModal] = React.useState(false);

  React.useEffect(() => {
    dispatch(actions.doGetList());
    return () => {};
  }, [pageNo, pageSize, search, orderDir, orderBy]);

  const handleDelete = () => {
    dispatch(
      actions.doDelete({
        id: selectedId as string,
        index: selectedIndex as number,
        callback() {
          setSelectedId(null);
          setSelectedIndex(null);
          setShowModal(false);
          dispatch(actions.doGetList());
        },
      })
    );
  };

  const columnHelper = createColumnHelper<IData>();
  const columns = [
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.sNo")}`,
      cell: (info) => {
        return (
          <>
            {pageNo === 1 ? (
              <>{info.row.index + 1}</>
            ) : (
              <>{`${(pageNo - 1) * pageSize + info.row.index + 1}`}</>
            )}
          </>
        );
      },
    }),
    columnHelper.accessor("states", {
      id: "states",
      header: `${t("shipping.form.state")}`,
      cell: (info) => {
        return <Text>{info?.row?.original?.states?.join(" , ") || "NA"}</Text>;
      },
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: `${t("common.list.createdAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
       sortDescFirst: true,
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: `${t("common.list.updatedAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
    }),
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.actions")}`,
      cell: (info) => {
        return (
          <HStack>
            <Tooltip label={`${t("common.list.edit")}`}>
              <IconButton
                aria-label="Edit"
                icon={<EditIcon />}
                onClick={() => {
                  navigate(`/admin/shipping/create/${info.row.original._id}`);
                }}
              />
            </Tooltip>
            <Tooltip label={`${t("common.list.delete")}`} hasArrow>
              <IconButton
                disabled={info.row.index === selectedIndex && buttonLoading}
                icon={<DeleteIcon />}
                size="sm"
                colorScheme="red"
                variant="ghost"
                onClick={() => {
                  setShowModal(true);
                  setSelectedId(info.row.original._id);
                  setSelectedIndex(info.row.index);
                }}
                aria-label="Delete FAQ"
              />
            </Tooltip>
          </HStack>
        );
      },
    }),
  ];

  const handleAddNew = () => {
    dispatch(actions.setSearch(""));
    navigate("/admin/shipping/create");
    dispatch(actions.clearFrom());
  };
  return (
    <>
      <CommonTable<IData>
        columns={columns}
        data={tableData}
        totalCount={total}
        pageNo={pageNo}
        pageSize={pageSize}
        search={search}
        loading={loading}
        onSearch={(v) => dispatch(actions.setSearch(v))}
        onPageChange={(p) => dispatch(actions.setPageNo(p))}
        onPageSizeChange={(s) => dispatch(actions.setPageSize(s))}
        onSortChange={(id, desc) => {
          dispatch(actions.setOrderBy(id));
          dispatch(actions.setOrderDir(desc ? "desc" : "asc"));
        }}
        handleAddNew={handleAddNew}
      />
      {showModal && (
        <ConfirmationModal
          open={showModal}
          loading={buttonLoading}
          title={`${t("common.text.deleteConfirm")}`}
          content={`${t("common.text.deleteConfirmation")}`}
          buttonText={`${t("common.button.delete")}`}
          onClose={() => {
            setShowModal(false);
          }}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
}
